import './javascript/modalBus';

$(document).ready(function() {
  $('[role=modal-dispatcher]').click(function() {
    Utilities.showModalByDataAction($(this).attr('data-action'));
  });
});
